import { useCallback } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconFolderFilled } from 'src/assets/icons/IconFolderFilled';
import { ProjectFolderActionsDropdown } from 'src/components/ProjectFolderActionsDropdown';
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { PROJECT_FOLDER_ACTIONS } from 'src/data/project';

import { ProjectFolderDescription } from '../ProjectFolderDescription';

import { useStyles } from './useStyles';

const propTypes = {
  projectFolders: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onProjectFolderAction: PropTypes.func.isRequired,
  hideActions: PropTypes.bool,
};
const defaultProps = {
  hideActions: false,
};

export const ProjectFolderTableRows = ({ projectFolders, onProjectFolderAction, hideActions }) => {
  const styles = useStyles();

  const handleRowClick = useCallback(
    (event, projectFolder) => {
      event.preventDefault();
      event.stopPropagation();
      onProjectFolderAction(PROJECT_FOLDER_ACTIONS.click, projectFolder);
    },
    [onProjectFolderAction]
  );

  return projectFolders.map((projectFolder) => (
    <TableRow
      key={projectFolder.id}
      className={styles.root}
      onClick={(event) => handleRowClick(event, projectFolder)}
    >
      {!hideActions && <TableCell className={cx(styles.cell, styles.cellFavorite)}></TableCell>}

      <TableCell className={cx(styles.cell, styles.cellName)}>
        <div>
          <TruncatedTypography className={styles.name}>
            <IconFolderFilled className={styles.icon} />
            {projectFolder.name}
          </TruncatedTypography>
        </div>
      </TableCell>

      <TableCell className={cx(styles.cell, styles.cellType)}>Folder</TableCell>

      <TableCell className={cx(styles.cell, styles.cellDescription)}>
        <ProjectFolderDescription
          projectFolder={projectFolder}
          diffNow
        />
      </TableCell>

      {!hideActions && (
        <TableCell className={cx(styles.cell, styles.cellMenu)}>
          <ProjectFolderActionsDropdown
            className={styles.hiddenIcon}
            onProjectFolderAction={onProjectFolderAction}
            projectFolder={projectFolder}
          />
        </TableCell>
      )}
    </TableRow>
  ));
};

ProjectFolderTableRows.propTypes = propTypes;
ProjectFolderTableRows.defaultProps = defaultProps;
